import React, { useCallback, ReactElement } from 'react';
import { useJoin } from '../../../contexts/JoinContext';
import {
  ALL_MANDATORY_2PHOTOS,
  ALL_MANDATORY_3PHOTOS,
} from '../../../utils/evidentlyFeatures/onboardingFieldsMandatory/common';

const JoinPhotoCustomDescription = (): ReactElement => {
  const { onBoardingMandatoryVariant } = useJoin();

  const renderLabel = useCallback(() => {
    switch (onBoardingMandatoryVariant) {
      case ALL_MANDATORY_2PHOTOS:
        return (
          <>
            Upload at least <strong>2 photos.</strong>
          </>
        );
      case ALL_MANDATORY_3PHOTOS:
        return (
          <>
            Upload at least <strong>3 photos.</strong>
          </>
        );
      default:
        return (
          <>
            Upload at least <strong>1 photo.</strong>
          </>
        );
    }
  }, [onBoardingMandatoryVariant]);

  return (
    <div style={{ textAlign: 'center' }}>
      <p style={{ margin: '8px 0', marginBottom: 10 }}>{renderLabel()}</p>
      {
        'Multiple photos get more messages! Upload up to 6 at once! Your profile can have up to 20 photos and videos in total.'
      }
    </div>
  );
};

JoinPhotoCustomDescription.propTypes = {};

export default JoinPhotoCustomDescription;
